import { EDatasourceType } from "@kuika/kuika-cl-model";
import _ from "lodash";

class SqlService {
  static sqlServerDeclaredParametersRegex = /DECLARE\s+@\w+/gi;

  static sqlInternalParameterRegex = /@@\w+/gm;

  static parameterRegex = /@\w+/gm;

  static sqlServerParameterRegex = /@\w+/gm;

  static oracleParameterRegex = /:\w+/gm;

  static postgreParameterRegex = /:\w+/gm;

  static reservedWords = ["@rowcount"];

  static removeStringLiteralsRegex = /'[^']*'/g;

  static sqlCommentRegex = /--.*/g;

  static sqlMultiLineCommentRegex = /\/\*[\s\S]*?\*\//g;

  static getDeclaredParameters(statement: string): string[] {
    const matches: RegExpMatchArray | null = statement.match(SqlService.sqlServerDeclaredParametersRegex);

    if (!matches) {
      return [];
    }

    return _.uniq(matches.map((match) => match.split(" ")[1]));
  }

  static getSqlParameters(datasourceType: EDatasourceType | undefined, statement: string): string[] {
    const statementWithoutSqlComments = statement.replace(SqlService.sqlCommentRegex, "");
    const statementWithoutStringLiterals = statementWithoutSqlComments.replace(
      SqlService.removeStringLiteralsRegex,
      ""
    );
    const statementWithoutMultiLineComments = statementWithoutStringLiterals.replace(
      SqlService.sqlMultiLineCommentRegex,
      ""
    );

    const statementWithoutInternalParameters = statementWithoutMultiLineComments.replace(
      SqlService.sqlInternalParameterRegex,
      ""
    );

    const declaredParameters: string[] = this.getDeclaredParameters(statementWithoutInternalParameters);

    const parameterRegex = this.getParameterRegex(datasourceType);
    const matches: RegExpMatchArray | null = statementWithoutInternalParameters.match(parameterRegex);

    if (!matches) {
      return [];
    }

    return _.uniq(this.filterReservedWords(matches)).filter((match) => !declaredParameters.includes(match));
  }

  static filterReservedWords(matched: string[]) {
    var result = [] as string[];

    for (var i = 0; i < matched.length; i++) {
      if (this.reservedWords.indexOf(matched[i].toLowerCase()) != -1) {
        continue;
      }

      result.push(matched[i]);
    }

    return result;
  }

  static getParameterRegex(datasourceType: EDatasourceType | undefined) {
    switch (datasourceType) {
      case EDatasourceType.Oracle:
        return this.oracleParameterRegex;
      case EDatasourceType.ManagedDbOracle:
        return this.oracleParameterRegex;
      case EDatasourceType.ManagedDbPostgre:
        return this.postgreParameterRegex;
      case EDatasourceType.Postgre:
        return this.postgreParameterRegex;
      default:
        return this.sqlServerParameterRegex;
    }
  }
}

export default SqlService;
